<template>
    <div>
        <p class="is-size-3">
            {{ $t('Home.choose_project_type_for_creation') }}
        </p>
        <p class="is-size-5 has-text-eduloc-red">
            {{ $t('creation_project_description') }}
        </p>
        <div class="columns is-multiline pt-6">
            <div
                v-for="type in mapProjectTypes"
                :key="type.name"
                class="column is-6-tablet is-4-desktop is-one-fifth-widescreen"
            >
                <div v-if="canBeCreated((type))" class="notification cannot-create secondary-font" v-html="$t('cannot_create_more_projects')" :rel="'message_'+type.code" @mouseleave="hideMessage(type)"/>
                <article v-if="canBeCreated((type))" :rel="'card_'+type.code"  @mouseenter="showMessage(type)"  @click="openModal(type)" class="create-project"
                    :class="{ disabled: isDisabled(type) }"
                >
                <!--<article @click="openModal(type)" class="create-project"
                    :class="{ disabled: isDisabled(type) }"
                >-->
                    <div class="card-image px-0 py-0">
                        <figure class="image">
                            <img
                                :src="type.image"
                                :alt="$t(`Creation.${type.name}.title`)"
                            />
                        </figure>
                    </div>
                    <div class="card-content pt-2 px-0 pb-0">
                        <div class="has-text-centered pb-4">
                            <p
                                v-t="`Creation.${type.name}.title`"
                                class="
                                    is-size-5 is-uppercase
                                    has-text-black
                                    pb-2
                                "
                            />
                            <div class="columns is-vcentered">
                                <div
                                    class="column is-12 px-1"
                                    style="min-height: 50px"
                                >
                                    <p
                                        v-html="
                                            $t(
                                                `Creation.${type.name}.description`
                                            )
                                        "
                                        class="is-size-6 has-text-centered secondary-font-semi"
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                </article>
            </div>
        </div>

        <p class="is-size-5 has-text-eduloc-red">
            {{ $t('creation_project_without_map_description') }}
        </p>
        <div class="columns is-multiline pt-6">
            <div
                v-for="type in projectTypes"
                :key="type.name"
                class="column is-6-tablet is-4-desktop is-one-fifth-widescreen"
            >
                <div v-if="canBeCreated((type))" class="notification cannot-create secondary-font" v-html="$t('cannot_create_more_projects')" :rel="'message_'+type.code" @mouseleave="hideMessage(type)"/>
                <article :rel="'card_'+type.code" v-if="canBeCreated((type))" @mouseenter="showMessage(type)"  @click="openModal(type)" class="create-project"
                    :class="{ disabled: isDisabled(type) }"
                >
                    <div class="card-image px-0 py-0">
                        <figure class="image">
                            <img
                                :src="type.image"
                                :alt="$t(`Creation.${type.name}.title`)"
                            />
                        </figure>
                    </div>
                    <div class="card-content pt-2 px-0">
                        <div class="has-text-centered pb-4">
                            <p
                                v-t="`Creation.${type.name}.title`"
                                class="
                                    is-size-5 is-uppercase
                                    has-text-black
                                    pb-2
                                "
                            />
                            <div class="columns is-vcentered">
                                <div
                                    class="column is-12 px-0"
                                    style="min-height: 50px"
                                >
                                    <p
                                        v-html="
                                            $t(
                                                `Creation.${type.name}.description`
                                            )
                                        "
                                        class="is-size-6 has-text-centered secondary-font-semi"
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                </article>
            </div>
        </div>


        <new-project-modal :type="activeType" @create="createProject" @cancel="creationActive=false" v-if="creationActive"></new-project-modal>
    </div>
</template>

<script>
import NewProjectModal from '@/components/NewProjectModal';
export default {
    components: { NewProjectModal },
    data() {
        return {
            mapProjectTypes: [
                {
                    name: 'contentmap',
                    type: 'collection',
                    image: require('@/assets/images/project_map.png'),
                    mode: 'map',
                    free: true,
                    code: 'PROJECT_TYPE_MAP',
                    enabled: true,
                },
                {
                    name: 'trivialgeo',
                    type: 'trivial',
                    image: require('@/assets/images/project_geoquiz.png'),
                    mode: 'map',
                    free: true,
                    code: "PROJECT_TYPE_GEOQUIZ",
                    enabled: true,
                },
                {
                    name: 'treasurehunt',
                    type: 'treasurehunt',
                    image: require('@/assets/images/project_treasurehunt.png'),
                    free: true,
                    code: "PROJECT_TYPE_TREASUREHUNT",
                    enabled: true,
                },
                /*{
                    name: 'scape',
                    type: 'scape',
                    mode: 'map',
                    image: require('@/assets/images/project_gameboard.png'),
                    free: true,
                    code: "PROJECT_TYPE_SCAPE",
                    enabled: false,
                },*/
                {
                    name: 'quizhunt',
                    type: 'quizhunt',
                    image: require('@/assets/images/project_quizhunt.png'),
                    free: true,
                    code: "PROJECT_TYPE_QUIZHUNT",
                    enabled: true,
                },
                /*{
                    name: 'memory',
                    type: 'memory',
                    image: require('@/assets/images/project_memory.png'),
                    free: true,
                    code: "PROJECT_TYPE_MEMORY",
                },*/
                {
                    name: 'memory',
                    type: 'memory',
                    image: require('@/assets/images/project_memory.png'),
                    free: false,
                    code: "PROJECT_TYPE_MEMORY",
                    enabled: true,
                },
            ],
            projectTypes: [
                {
                    name: 'collection',
                    type: 'collection',
                    image: require('@/assets/images/project_wall.png'),
                    free: true,
                    code: "PROJECT_TYPE_WALL",
                    enabled: true,
                },
                {
                    name: 'trivial',
                    type: 'trivial',
                    image: require('@/assets/images/project_quiz.png'),
                    free: true,
                    code: "PROJECT_TYPE_QUIZ",
                    enabled: true,
                },
                
            ],
            activeType: {},
            creationActive: false,
            openMessage: true,
        };
    },
    computed: {
        isAdmin() {
            return this.$store.getters.isAdmin;
        },
        projectTypeNumber() {
            return this.$store.getters.user ? this.$store.getters.user.data.projectsPerType : [];
        },
        projectTypeMaxNumber() {
            return this.$store.getters.activePlan ? this.$store.getters.activePlan.configuration.project.perTypeMaxNumber : 0
        },
        enabledTypes() {
            return this.$store.getters.activePlan ? this.$store.getters.activePlan.configuration.project.type : []
        }
    },
    mounted() { 
        //console.log("max projects per type",this.$store.getters.activePlan.configuration.project.perTypeMaxNumber,this.$store.getters.user.data.projectsPerType)
    },
    methods: {
        isDisabled(type) {
            return (this.enabledTypes.indexOf(type.code)===-1 || (this.projectTypeMaxNumber <= this.projectTypeNumber[type.code] && this.projectTypeMaxNumber!=-1))
        },
        canBeCreated(type) {
            if ((!type.free && this.isAdmin) || type.free) {
                return true;
            } 
            return false;
        },
        createProject(projectData){
            /*if (this.activeType.free){
                // console.log(projectData),
                projectData.type = this.activeType;
                this.$emit('click', projectData);
            }*/
            // console.log(this.enabledTypes.indexOf(this.activeType.type.code), this.activeType.code)
            
            if(!this.isDisabled(this.activeType)){ //if (this.enabledTypes.indexOf(this.activeType.code) !== -1) {
                projectData.type = this.activeType;
                this.$emit('click', projectData);
            }
        },
        openModal(type){
            /*if (type.free){
                this.activeType = type;
                this.creationActive = true;
            }*/
            if(!this.isDisabled(type)){
            // if (this.enabledTypes.indexOf(type.code) !== -1) {
                this.activeType = type;
                this.creationActive = true;
            }
        },
        showMessage(type) {
            //console.log(type,this.isDisabled(type))
            if (this.isDisabled(type) && type.enabled) {
                // console.log("limit reached for ", type)
                //this.openMessage = true;
                const message = document.querySelector(`[rel='message_${type.code}']`);
                const card = document.querySelector(`[rel='card_${type.code}']`);
                message.style.display = 'block';
                card.style.display = 'none';
                // console.log(message,card)
            }
        },
        hideMessage(type) {
            // console.log(type,this.isDisabled(type))
            if (this.isDisabled(type) && type.enabled) {
                // console.log("limit reached for ", type)
                //this.openMessage = false;
                const message = document.querySelector(`[rel='message_${type.code}']`);
                const card = document.querySelector(`[rel='card_${type.code}']`);
                message.style.display = 'none';
                card.style.display = 'block';
                // console.log(message,card)
            }
        }
    },
    props: {
        showTitles: {
            type: Boolean,
            default: true,
        },
        showButtons: {
            type: Boolean,
            default: true,
        },
    },
};
</script>

<style scoped>
.create-project {
    cursor: pointer;
}
.create-project.disabled {
    opacity: 0.4;
    cursor: auto;
}
img {
    object-fit: contain;
}
.notification.cannot-create{
    position: relative;
    z-index: +1;
    left: 0;
    display: none;
    cursor: not-allowed;
    font-size: 1rem;
    background-color: #000000;
    color:#FFFFFF;
}
</style>
